import { gql } from 'graphql-tag'
import fragmentEventAgendaSection from '../event-agenda-section/fragment-event-agenda-section'
import { fragmentGlobalDataTheme } from '#layers/core/data-layer/global-data/fragments'

export default gql`
  ${fragmentGlobalDataTheme}
  ${fragmentEventAgendaSection}
  fragment EventBlockAgendaFragment on EventBlockAgenda {
    sys {
      id
    }
    contentType: __typename
    title
    blockAgendaDescription: description {
      json
    }
    agendaSectionsCollection {
      items {
        ...EventAgendaSectionFragment
      }
    }
    theme {
      ...GlobalDataThemeFragment
    }
  }
`
